<template>
    <div class="card">
        <div class="listview listview--bordered listview--block">
            <div class="listview__item">
                <h4 class="card-title"><i class="zmdi zmdi-comments mr-2"></i><span>{{ $t('LBL_COMMENTS') }}</span></h4>
            </div>

            <div class="messages">
                <div class="messages__body">
                    <div class="messages__content">
                        <div class="scrollbar-inner">
                            <div class="messages__item" v-for="comment in comments" :class="{'messages__item--right': isMyComment(comment)}">
                                <div class="messages__details">
                                    <p>{{ comment.commentcontent.displayValue }}</p>
                                    <small><i class="zmdi zmdi-time"></i> <span v-if="!isMyComment(comment)" class="font-weight-bold">{{ $t('LBL_COMMENTED_BY') }} {{ comment.creator.displayValue }}</span> {{ comment.modifiedtime.displayValue }}</small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="messages__reply p-5">
                        <form class="commentForm" @submit.prevent="submit">
                            <div class="form-group">
                                <textarea-field v-bind="commentField" v-model="commentField.value"></textarea-field>
                                <i class="form-group__bar"></i>
                            </div>
                            <div class="row">
                                <div class="col-sm-3">
                                    <button class="btn btn-primary btn--icon-text"><i class="zmdi zmdi-mail-send"></i>{{ $t('LBL_SEND_COMMENT') }}</button>
                                </div>
                                <div class="col-sm-9">
                                    <dropzone ref="dropzone" id="filename" name="filename"></dropzone>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TextAreaField from '@/components/form_elements/TextArea'
    import DropZone from '@/components/form_elements/DropZone'

    export default {
        components: {
            'textarea-field': TextAreaField,
            'dropzone': DropZone
        },

        data() {
            return {
                commentField: {
                    name: 'commentcontent',
                    mandatory: true,
                    isFloat: true,
                    placeHolder: this.$t('LBL_TYPE_A_COMMENT'),
                    value: ''
                },
                comments: []
            }
        },

        props: {
            record: ''
        },

        $_veeValidate: { validator: "new" },

        methods: {
            load() {
                Api.fetchList('ModComments', this.record).then(list => {
                    if(list.result){
                        this.comments = list.result.entries
                    }
                })

                /*setTimeout(() => {
                    vm.scrollToBottom($('.messages .scroll-content', $(vm.$el))[0])
                }, 100)*/
            },

            async submit() {
                await this.$validator.validateAll()

                if (!this.errors.any() && !this.loader) {
                    // Create comment
                    var response = await Api.save('ModComments', $('.commentForm', this.$el).serializeFormData(), this.record)

                    if(response.success){
                        this.commentField.value = ''
                        this.load()
                    }
                    else{
                        AppHelper.notify('Error occurred', 'warning')
                    }

                    // Attach files
                    let files = this.$refs.dropzone.getFiles()
                    for(let key in files){
                        let file = files[key]
                        Api.save('Documents', {notes_title: file.name, filelocationtype: 'I', filestatus: 1},
                            this.record, {'filename': file})
                    }

                    this.clear()
                }
            },

            clear() {
                this.commentField.value = ''
                this.$refs.dropzone.clear()
            },

            isMyComment(comment) {
                if(comment.creator.value === this.$store.state.structure.settings.user_id){
                    return true
                }

                return false
            }
        },

        mounted() {
            this.load()
        }
    }
</script><style lang="scss">@import "@/assets/scss/components/_comments.scss";</style>